import { Message } from 'shared/api/requests/chat/schemas'

import { ChatMessageType } from '../types/chatMessageTypeList'
import { LabelFeedback } from '../types/labelsFeedback'

export const isSubscriberLabelledByAiMessage = (
  item: Message,
): item is Message & {
  type: typeof ChatMessageType.SUBSCRIBER_LABELED_BY_AI
  model: { label_id: number; label_name: string; feedback_status?: LabelFeedback }
} => {
  return item.type === ChatMessageType.SUBSCRIBER_LABELED_BY_AI
}

export const isAiLabelUndoMessage = (
  item: Message | undefined,
): item is Message & {
  model: { feedback_message_id: string; feedback_status?: LabelFeedback }
} => {
  return Boolean(
    item?.model && typeof item.model === 'object' && 'feedback_message_id' in item.model,
  )
}
